import { getMaterialIconComponent } from 'app/components/MaterialIconMap';
import { PromptData } from './types';

export const filterPromptsBySearch = (
  prompts: PromptData[],
  searchQuery: string
) => {
  if (!searchQuery.trim()) return prompts;
  
  return prompts.filter(prompt => {
    const matchesSearch = prompt.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         prompt.subtitle.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearch;
  });
};

export const transformOperationsToPrompts = (
  operations: Array<{
    id: string;
    display_text: string;
    description: string;
    action: string;
    icon: string;
  }>,
  selectedCategory: string
): PromptData[] => {
  return operations.map(op => ({
    id: op.id,
    title: op.display_text,
    subtitle: op.description,
    icon: getMaterialIconComponent(op.icon) || getMaterialIconComponent('generated_by_ai'),
    category: selectedCategory,
    action: op.action,
  }));
};
